import { render, staticRenderFns } from "./OnboardingStep4.vue?vue&type=template&id=5fe5e039&scoped=true"
import script from "./OnboardingStep4.vue?vue&type=script&lang=js"
export * from "./OnboardingStep4.vue?vue&type=script&lang=js"
import style0 from "./OnboardingStep4.vue?vue&type=style&index=0&id=5fe5e039&prod&lang=scss"
import style1 from "./OnboardingStep4.vue?vue&type=style&index=1&id=5fe5e039&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fe5e039",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VForm } from 'vuetify/lib/components/VForm';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VForm,VTextField})
